// extracted by mini-css-extract-plugin
module.exports = {"officeContactInfo":"OfficeContactInfo_officeContactInfo__jDX1W","address":"OfficeContactInfo_address__uRUQD"};